import type { Address } from "viem"
import { action, makeObservable, observable, runInAction } from "mobx"

import type { IVenammStore } from "./interfaces"
import type { VenammStoreDAO } from "./types"

export class VenammStore implements IVenammStore {
  venAmmAddress: Address
  availableTokenSupply: bigint = 0n
  availableTokenSupplyValue: number = 0

  constructor(data: VenammStoreDAO) {
    this.venAmmAddress = data.venAmmAddress
    this.availableTokenSupply = data.availableTokenSupply
    this.availableTokenSupplyValue = data.availableTokenSupplyValue

    makeObservable(this, {
      venAmmAddress: observable,
      availableTokenSupply: observable,
      availableTokenSupplyValue: observable,
      updateAvailableTokenSupply: action,
    })
  }

  updateAvailableTokenSupply(supply: bigint, value: number): void {
    runInAction(() => {
      this.availableTokenSupply = supply
      this.availableTokenSupplyValue = value
    })
  }
}
